export default __webpack_public_path__ + "static/media/ec-sn022.3ca3455a.mp3";